import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useState, useEffect } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Coverage", href: "#coverage" },
    { label: "How it works", href: "#how-it-works" },
    { label: "About Darryl", href: "#about" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-pp-bone/85 backdrop-blur-md border-b border-pp-border-subtle"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="w-9 h-9 rounded-full bg-pp-forest flex items-center justify-center text-pp-bone font-serif text-xl">
            P
          </span>
          <span className="font-serif text-2xl tracking-tight text-pp-forest-deep">
            Policy Provisions
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-pp-text-secondary hover:text-pp-forest-deep transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link to="/quote">
            <Button
              data-testid="nav-quote-btn"
              className="bg-pp-terracotta hover:bg-pp-terracotta-dark text-white rounded-full px-6 py-5 font-medium"
            >
              Get a Quote
            </Button>
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-pp-forest-deep"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-pp-bone border-t border-pp-border-subtle px-6 py-6 space-y-4">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-base text-pp-forest-deep"
            >
              {l.label}
            </a>
          ))}
          <Link to="/quote" onClick={() => setOpen(false)}>
            <Button
              data-testid="nav-mobile-quote-btn"
              className="w-full bg-pp-terracotta hover:bg-pp-terracotta-dark text-white rounded-full mt-2"
            >
              Get a Quote
            </Button>
          </Link>
        </div>
      )}
    </header>
  );
}
